<template>
    <transition name="confirm-fade">
      <div v-if="isShowConfirm" class="my-confirm" @click.stop="clickFun('clickCancel')">
        <div class="wrap" @click.stop>
          <div :class="['sign-block', { 'container-dark': theme_dark }]">
            <div class="head-txt ub ub-pc ub-ac">
              <h3>连续签到领积分</h3>
            </div>
  
            <div class="middle-txt ub ub-pc ub-ac">
              <div class="d1"></div>
              <span>已连续签到{{ is_sign == 1 ? is_sign_day + 1 : is_sign_day }}天</span>
              <div class="d2"></div>
            </div>
  
            <ul class="end-block">
              <li class="end">
                <div :class=" is_sign_day > 0 || (is_sign == 1 && is_sign_day == 0) ? 'item' : 'item2'">
                  <span class="sp1">{{ is_sign_day == 0 ? "今天" : "第1天" }}</span>
                  <img :src="is_sign_day > 0 || (is_sign == 1 && is_sign_day == 0) ? imgUrl : imgUrl2"/>
                  <span class="sp2">10积分</span>
                </div>
              </li>
              <li class="end">
                <div :class=" is_sign_day > 1 || (is_sign == 1 && is_sign_day == 1) ? 'item' : 'item2'">
                  <span class="sp1">{{  is_sign_day == 1 ? "今天" : "第2天" }}</span>
                  <img :src=" is_sign_day > 1 || (is_sign == 1 && is_sign_day == 1) ? imgUrl : imgUrl2"/>
                  <span class="sp2">20积分</span>
                </div>
              </li>
              <li class="end">
                <div :class=" is_sign_day > 2 || (is_sign == 1 && is_sign_day == 2) ? 'item' : 'item2' ">
                  <span class="sp1">{{ is_sign_day == 2 ? "今天" : "第3天"}}</span>
                  <img :src=" is_sign_day > 2 || (is_sign == 1 && is_sign_day == 2) ? imgUrl : imgUrl2"/>
                  <span class="sp2">30积分</span>
                </div>
              </li>
              <li class="end">
                <div :class=" is_sign_day > 3 || (is_sign == 1 && is_sign_day == 3) ? 'item' : 'item2'">
                  <span class="sp1">{{is_sign_day == 3 ? "今天" : "第4天"}}</span>
                  <img :src=" is_sign_day > 3 || (is_sign == 1 && is_sign_day == 3) ? imgUrl : imgUrl2"/>
                  <span class="sp2">40积分</span>
                </div>
              </li>
            </ul>
  
            <ul class="end-block2">
              <li class="end">
                <div :class="is_sign_day > 4 || (is_sign == 1 && is_sign_day == 4) ? 'item' : 'item2'">
                  <span class="sp1">{{is_sign_day == 4 ? "今天" : "第5天"}}</span>
                  <img :src="is_sign_day > 4 || (is_sign == 1 && is_sign_day == 4)? imgUrl : imgUrl2"/>
                  <span class="sp2">50积分</span>
                </div>
              </li>
              <li class="end">
                <div :class=" is_sign_day > 5 || (is_sign == 1 && is_sign_day == 5) ? 'item' : 'item2'">
                  <span class="sp1">{{is_sign_day == 5 ? "今天" : "第6天"}}</span>
                  <img :src="is_sign_day > 5 || (is_sign == 1 && is_sign_day == 5)? imgUrl: imgUrl2"/>
                  <span class="sp2">60积分</span>
                </div>
              </li>
              <li class="end2">
                <div :class=" is_sign_day > 6 || (is_sign == 1 && is_sign_day == 6) ? 'item4' : 'item3'">
                  <span class="sp1">{{is_sign_day == 6 ? "今天" : "第7天"}}</span>
                  <img :src="is_sign_day > 6 || (is_sign == 1 && is_sign_day == 6)? imgUrl: imgUrl2"/>
                  <span class="sp2">100积分</span>
                </div>
              </li>
            </ul>
  
            <div v-if="is_sign == 0" class="sign-btn-block ub ub-ac" @click="sign()">
              <div class="sign-btn ub ub-pc ub-ac"><span>签到</span></div>
            </div>
            <div v-if="is_sign > 0" class="sign-btn-block ub ub-ac" @click="sign()">
              <div class="sign-btn2 ub ub-pc ub-ac"><span>已签到</span></div>
            </div>
          </div>
          <div class="ub ub-pc ub-ac">
            <img class="close-img" src="../assets/img/new2024/close.png" @click="hidden()"/>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  import { mapMutations, mapActions } from "vuex";
  import * as tool from "../api/common";
  export default {
    props:['SignState'],
    data() {
      return {
        isShowConfirm: false, // 用于控制整个窗口的显示/隐藏
        is_sign: 0,
        is_sign_day: 0,
        // imgUrl: require("../assets/img/金币.png"),
        imgUrl: require("../assets/img/new2024/score1.png"),
        // imgUrl2: require("../assets/img/金币灰色.png"),
        imgUrl2: require("../assets/img/new2024/score1.png"),
        theme_dark: false
      };
    },
    mounted() {
      
      this.init_page();
    },
    methods: {
      ...mapMutations(["get", "post"]), //引入方法
      ...mapActions(["act_reload_userinfo", "act_get_userinfo"]), //引入方法
  
      init_page() {
        var my_sign = this.$store.state.http_cache.my_sign;
        if (my_sign.sign_count != -1) {
          this.is_sign_day = parseInt(my_sign.sign_count);
          return true;
        }
        
        var self = this;
        var uid = this.$store.state.uid;
        this.get({
          url: "/App/Sign_Count/?uid=" + uid,
          success: function (data) {
            var obj = {
                is_sign: my_sign.is_sign,
                sign_count: data
              }
            self.$store.commit("set_http_cache", {my_sign: obj});
  
            self.is_sign_day = parseInt(data);
          },
          error: function (err) {},
        });
      },
  
      show(is_sign) {
        //切换深色模式
        this.theme_dark = tool.is_theme_dark(this);
        this.isShowConfirm = true;
        this.is_sign = is_sign;
      },
      hidden() {
        this.$emit('SignState',this.is_sign);
        this.isShowConfirm = false;
      },
      clickFun(type) {
        this.hidden();
      },
  
      sign() {
        var self = this;
        if (self.is_sign == 1) {
          self.$toast.center("今日已签，明日再来~");
          return;
        }
        var uid = self.$store.state.uid;
        self.get({
          url: "/App/Sign/?uid=" + uid,
          success: function (data) {
            //console.log(JSON.stringify(data));
            //self.is_sign == data;
            if (data.state == "-1") {
              self.$toast.center(data.msg);
            }
            if (data.state == "1") {
              var my_sign = self.$store.state.http_cache.my_sign;
              var sign_count = my_sign.sign_count;
              var obj = {
                is_sign: 1,
                sign_count: sign_count
              }
              self.$store.commit("set_http_cache", {my_sign: obj});
  
              var msg = "签到成功，获得" + data.msg + "积分";
              self.$toast.center(msg);
              self.is_sign = 1;
              
              self.act_reload_userinfo({
                uid: uid,
                success: function (info) {},
              });
              //发送签到成功的通知
              self.sendwxmsg(msg);
            }
            if (data.state == "0") {
              self.$toast.center(data.msg);
            }
          },
          error: function (err) {},
        });
      },
      sendwxmsg(msg) {
        var uid = this.$store.state.uid;
        var tag = "6";
        var day2 = new Date();
        day2.setTime(day2.getTime());
        var s2 =
          day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate();
        var data = {
          first: msg,
          keyword1: s2,
          keyword2: "小火柴新版",
        };
  
        var strData = JSON.stringify(data);
        //console.log(strData);
        //return false;
  
        var self = this;
        this.post({
          url: "/Common/WxSendMsg2",
          data: { uid: uid, tag: tag, data: strData },
          success: function (serve_data) {
            //console.log(JSON.stringify(data));
          },
        });
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .my-confirm {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 998;
    /* 这里防止当用户长按屏幕，出现的黑色背景色块，以及 iPhone 横平时字体的缩放问题 */
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  
  /* 进入和出去的动画 */
  .confirm-fade-enter-active {
    animation: opacity 0.3s;
  }
  .confirm-fade-leave-active {
    animation: outOpacity 0.2s;
  }
  /* 进来的动画 */
  @keyframes opacity {
    0% {
      opacity: 0;
    }
  
    100% {
      opacity: 1;
    }
  }
  
  /* 出去的动画 */
  @keyframes outOpacity {
    0% {
      opacity: 1;
    }
  
    100% {
      opacity: 0;
    }
  }
  
  /* 包裹层容器样式 */
  .wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 85%;
    margin: 0 auto;
    z-index: 999;
    border-radius: 2rem;
    user-select: none;
  }
  
  .sign-block {
    padding: 0.8rem 0.8rem 0 0.8rem;
    border-radius: 1rem;
    background: linear-gradient(to bottom, #FE9CC0, #fff 3rem);
    .head-txt {
      display: flex;
      align-items: center;
      h3 {
        font-weight: bold;
        color: #6c1aab;
      }
    }
    
    .middle-txt {
      margin-top: 2rem;
      .d1 {
        background-image: linear-gradient(to right, #fff, #ba61ff);
        height: 2px;
        width: 4rem;
      }
      .d2 {
        background-image: linear-gradient(to left, #fff, #ba61ff);
        height: 2px;
        width: 4rem;
      }
      span {
        font-size: 0.75rem;
        margin: 0 1.5rem;
        color: #ba61ff;
      }
    }
  
    .end-block {
      margin-top: 1.5rem;
      display: flex;
      justify-content: space-between;
      .end {
          display: flex;
      }
    }
  
    .end-block2 {
      margin-top: 0.5rem;
      display: flex;
      justify-content: space-between;
      .end {
          display: flex;
      }
    }
  
    .item {
      padding: 0.4rem 0;
      display: flex;
      flex-direction: column;
      width: 4.2rem;
      height: 4.5rem;
      align-items: center;
      justify-content: space-around;
      border-radius: 0.5rem;
      background: linear-gradient( 180deg, #A264E7 0%, #FE9CC0 100%);
      .sp1 {
        color: #fff;
        font-size: 0.75rem;
      }
      img {
        width: 1.5rem;
        height: 1.5rem;
      }
      .sp2 {
        color: #fff;
        font-size: 0.75rem;
      }
    }
  
    .item2 {
      padding: 0.4rem 0;
      background-color: #e7e7e5;
      display: flex;
      flex-direction: column;
      width: 4.2rem;
      height: 4.5rem;
      align-items: center;
      justify-content: space-around;
      border-radius: 0.5rem;
      span {
        color: #888888;
        font-size: 0.75rem;
        font-weight: 500;
      }
      img {
        width: 1.5rem;
        height: 1.5rem;
        pointer-events: none;
      }
    }
    
    .item3 {
      padding: 0.4rem 0.1rem;
      background-color: #e7e7e5;
      display: flex;
      flex-direction: column;
      width: 8.7rem;
      height: 4.5rem;
      align-items: center;
      justify-content: space-around;
      border-radius: 0.5rem;
      img {
        width: 2.2rem;
        height: 2.2rem;
        pointer-events: none;
      }
      span {
        color: #888888;
        font-size: 0.75rem;
        font-weight: 500;
      }
    }
  
    .item4 {
      padding: 0.4rem 0.1rem;
      background: linear-gradient( 180deg, #A264E7 0%, #FE9CC0 100%);
      display: flex;
      flex-direction: column;
      width: 8.7rem;
      height: 4.5rem;
      align-items: center;
      justify-content: space-around;
      border-radius: 0.5rem;
      span {
        color: #fff;
        font-size: 0.75rem;
        font-weight: 500;
      }
      img {
        width: 2.2rem;
        height: 2.2rem;
        pointer-events: none;
      }
    }
  
    .sign-btn-block {
      padding: 1rem 0;
      span {
        font-size: 1rem;
        font-weight: bold;
        color: #ffffff;
      }
      .sign-btn {
        flex: 1;
        margin: 0 1rem;
        padding: 0.5rem 0;
        background: linear-gradient(90deg, #a264e7, #fe9cc0);
        border-radius: 2rem;
      }
      .sign-btn2 {
        flex: 1;
        margin: 0 1rem;
        padding: 0.5rem 0;
        background-color: #e7e7e5;
        border-radius: 2rem;
        span {
          color: #fff;
        }
      }
    }
  
  }
  
  .close-img {
      width: 2rem;
      margin-bottom: -4rem;
  }
  
  .container-dark {
    background: linear-gradient(to bottom, #9c365c, #333 3rem);
    .head-txt {
      h3 {
        color: #fff;
      }
    }
    .middle-txt {
      margin-top: 2rem;
      .d1 {
        background-image: linear-gradient(to right, #333, #ba61ff);
      }
      .d2 {
        background-image: linear-gradient(to left, #333, #ba61ff);
      }
      span {
        font-size: 0.75rem;
        margin: 0 1.5rem;
        color: #ba61ff;
      }
    }
    .middle-txt {
      span {
        color: #999;
      }
    }
    .item2 {
      background-color: #4d4d4b;
    }
    .item3 {
      background-color: #4d4d4b;
    }
    .sign-btn-block {
      .sign-btn2 {
        background-color: #4d4d4b;
  
      }
    }
  }
  </style>
  